/**
 * Categoriesticker op de dealkaart (Dennis 25-10-2026, "Sticker zonder
 * korting"): een kerstmarktdeal toont "Hotel + kerstmarkt" op de plek van de
 * kortingsbadge, zonder bedrag of percentage (de kerstprijzen staan stil, dus
 * er is geen kortingsclaim). De sticker hangt alleen van de categorie af, nooit
 * van de bezoeker, zodat de gecachete HTML voor iedereen gelijk blijft.
 *
 * De categorie komt uit `category_ids` (array of JSON-string): dat veld stuurt
 * de BFF mee en staat in de kaartprojectie (pick-deal-for-card.js).
 *
 * Een categorie erbij: voeg een rij toe aan CATEGORY_STICKER_KEYS en de
 * i18n-sleutel in src/i18n/*.json.
 */
/** categorie-slug -> [i18n-sleutel, nl-terugval] */
export const CATEGORY_STICKER_KEYS = Object.freeze({
  kerstmarkten: Object.freeze(["deal.sticker.hotel_christmas_market", "Hotel + kerstmarkt"]),
});

function fieldTokens(raw) {
  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch {
      raw = [];
    }
  }
  return Array.isArray(raw) ? raw.map((c) => String(c).trim().toLowerCase()) : [];
}

/** Genormaliseerde lijst uit `category_ids` en de alias `categoryIds` samen. */
function categoryTokens(deal) {
  return [...fieldTokens(deal?.category_ids), ...fieldTokens(deal?.categoryIds)];
}

/**
 * [i18n-sleutel, terugval] van de categoriesticker van deze deal, of null.
 * Nooit voor ING-deals (`unlisted` of `ing-hub`): de sticker maakt ze niet
 * zichtbaarder.
 */
export function categoryStickerFor(deal) {
  if (!deal) return null;
  const tokens = categoryTokens(deal);
  if (tokens.includes("unlisted") || tokens.includes("ing-hub")) return null;
  for (const slug of Object.keys(CATEGORY_STICKER_KEYS)) {
    if (tokens.includes(slug)) return CATEGORY_STICKER_KEYS[slug];
  }
  return null;
}
